/** This file serves only as an agreggator so that we can do something like 'import {x, y, x} from "./_services"' * */
export { UserService } from './user.service';
export { ClientService } from './client.service';
export { CartService } from './cart.service';
export { CardsService } from './cards.service';
export { ProductsService } from './products.service';
export { AddressesService } from './addresses.service';
export { NewsService } from './news.service';
export { headerLinksService } from './headerLinks.service';
export { CountryStateService } from './countrystate.service';
export { WishProductsService } from './wishProducts.service';
export { TaxonomiesService } from './taxonomies.service';
export { OrdersService } from './orders.service';
export { RankingsService} from './rankings.service';
export { BannersService} from './banners.service';
export { BalanceService} from './balance.service';
export { AcceleratorsService} from './accelerators.service';
export { PagesService } from './pages.service';
export { SupportingDocumentsService } from './supportingDocuments.service';
export { AuthenticationService } from './authentication.service';
export { InvoiceService } from './invoice.service';
export { CampaignService } from './campaign.service';
export { ObjectiveService } from './objective.service';
export { NotificationsService } from './notifications.service';
export { QuizzService } from './quizz.service';
export { PopUpService } from './popup.service';
export { FeedService } from './feed.service';
export { AnalyticsService } from './analytics.service';
export { SaleAttributionService } from './saleAttribution.service';
export { SaleTradeService } from './saleTrade.service';
export { ChatService } from './chat.service';
export { PostsService } from './posts.service';
export { LevelService } from './level.service';
export { pointBlocksService } from './pointBlocks.service';
export { GroupPositionUserService } from './groupPositionUser.service';
export { bonusPointService } from './bonusPoint.service'
export { WalletService } from './wallet.service'
export { VoucherService } from './voucher.service'
